import type { Candidate } from '@/models/job';

/**
 * Meta CV previous/next list: the opened Kanban column when known,
 * otherwise the Table's visible (filtered + sorted) candidates.
 */
export function getMetaCvNavigationCandidates(
  columnCandidateIds: readonly string[] | null,
  candidates: readonly Candidate[],
  tableCandidates: Candidate[]
): Candidate[] {
  if (!columnCandidateIds) return tableCandidates;
  const byId = new Map(candidates.map((candidate) => [candidate.id, candidate]));
  return columnCandidateIds.flatMap((id) => {
    const candidate = byId.get(id);
    return candidate ? [candidate] : [];
  });
}

export interface CandidateNeighbors {
  index: number;
  previousId: string | null;
  nextId: string | null;
}

/** A current candidate missing from `list` (index -1) keeps "next" pointing at the first entry. */
export function getCandidateNeighbors(
  list: readonly Candidate[],
  currentId: string | undefined
): CandidateNeighbors {
  const index = currentId ? list.findIndex((c) => c.id === currentId) : -1;
  return {
    index,
    previousId: index > 0 ? list[index - 1].id : null,
    nextId: list[index + 1]?.id ?? null,
  };
}
